import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Layout, Menu } from "antd";
import { dashboardMenus } from "./Dashboard.helper";
import DashboardInfo from "./Dashboard.info";
import { useLocation, useNavigate } from "react-router-dom";
import { getNavPath } from "../../routes/routes.helpers";
import useAccountBalance from "../../hooks/useAccountBalance";
import withUserData from "../../HOC/withUserData";
import { redirectAfterDelay } from "../../utils/utils";
const { Content, Sider } = Layout;

const Dashboard = ({ children, account, userData = {}, loggedInAsGuest = true}) => {
  const { firstName } = userData;
  const navigate = useNavigate();
  const location = useLocation();

  const pathName =  location.pathname;
  const pathParts = pathName.split('/').filter(Boolean);
  

  const [activeKey, setActiveKey] = useState(pathParts[0] || '');

  const getMenuItems = useMemo(() => {
    if (activeKey) {
      return dashboardMenus(activeKey);
    }
    return [];
  }, [activeKey]);

  const handleClick = useCallback(
    (e) => {
      setActiveKey(e.key);
      navigate('/' + e.key);
    },
    [navigate, location, loggedInAsGuest]
  );

  useEffect(() => {
    const whiteListedKeys = ['transactions', 'account'];

    if (loggedInAsGuest && whiteListedKeys.includes(activeKey)) {
      redirectAfterDelay("/login");
      return;
    } 
    
    const activeBasePathName = "/" + activeKey;

    if (pathName.startsWith(activeBasePathName)) {
      navigate(pathName);
    }
    else {
      navigate(getNavPath(activeKey));
    }
  }, [loggedInAsGuest, activeKey]);

  const { accountDetails, accountBalance } = useAccountBalance();
  const localAccount = account || accountDetails;

  return (
    <Content className="dashboard">
      <Layout className="dashboard__layout">
        <Sider className="dashboard__side hide-side-menu">
          <div className="card">
            <DashboardInfo
              balance={accountBalance}
              username={firstName}
              loggedInAsGuest={loggedInAsGuest}
              bankName={localAccount?.bank_name}
              accountNumber={localAccount?.account_number}
            />
          </div>
          <br />
          <Menu
            mode="inline"
            className="dashboard__menu"
            selectedKeys={[activeKey]}
          >
            {getMenuItems.map(({ key, icon, label }) => (
              <Menu.Item
                className="dashboard__menu_item"
                icon={icon}
                key={key}
                onClick={handleClick}
              >
                <Fragment>
                  {label}
                  {activeKey === key && (
                    <ion-icon name="arrow-forward-outline"></ion-icon>
                  )}
                </Fragment>
              </Menu.Item>
            ))}
          </Menu>
        </Sider>
        <Content className="dashboard__content">{children}</Content>
      </Layout>
    </Content>
  );
};


export default withUserData(Dashboard);
